import { render, staticRenderFns } from "./ProjectImportDialog.vue?vue&type=template&id=66ef7148&scoped=true&"
import script from "./ProjectImportDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectImportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ef7148",
  null
  
)

export default component.exports